import React from 'react'
import { menuItemsData } from "../menuItemsData";
import MenuItems from "./MenuItems";

const nanobar = () => {
    const depthLevel = 0;
    return (
        <nav className="main-nav">
            <ul className="menus">
                {menuItemsData.map((menu, index) => {
                    return (
                        <MenuItems items={menu} key={index} depthLevel={depthLevel} />
                    );
                })}
            </ul>
            <hr className="mx-auto" style={{ borderTop: '3px solid #000' }} />
        </nav>
    );
};

export default nanobar;

